import { Field } from "formik";
import React, { useEffect } from "react";
import { Card, CardBody, FormGroup, Input, Label } from "reactstrap";

export const PackagePricing = ({formikProps}) => {
  return (
    <Card className="h-100 border-0 shadow-sm">
      <CardBody className="p-4">
        <Label
          className="text-secondary mb-3 d-flex align-items-center"
          style={{ fontWeight: 600 }}
        >
          <i className="bi bi-cash-stack mr-2 ctf-tx-primary"></i>
          Pricing Structure
        </Label>
        <FormGroup tag="fieldset" className="mb-0">
          <div className="d-flex flex-column flex-md-row gap-3">
            <div
              className="flex-fill p-3 position-relative"
              style={{
                cursor: "pointer",
                transition: "all 0.2s",
                background:
                  formikProps.values.pricingType === "static"
                    ? "#e7f3ff"
                    : "white",
                borderColor:
                  formikProps.values.pricingType === "static"
                    ? "#0d6efd"
                    : "#dee2e6",
                borderWidth:
                  formikProps.values.pricingType === "static" ? "2px" : "1px",
              }}
              onClick={() => formikProps.setFieldValue("pricingType", "static")}
            >
              <FormGroup check className="mb-0">
                <Label
                  check
                  className="d-flex align-items-start w-100"
                  style={{ cursor: "pointer" }}
                >
                  <Field
                    type="radio"
                    name="pricingType"
                    value="static"
                    className="mt-1"
                  />
                  <div className="ml-2 flex-fill">
                    <div className="fw-semibold mb-1">Static Fee</div>
                    <small className="text-muted">
                      Add a fixed fee per extra person
                    </small>
                  </div>
                </Label>
              </FormGroup>
            </div>

            <div
              className="flex-fill p-3  position-relative"
              style={{
                cursor: "pointer",
                transition: "all 0.2s",
                background:
                  formikProps.values.pricingType === "tiered"
                    ? "#e7f3ff"
                    : "white",
                borderColor:
                  formikProps.values.pricingType === "tiered"
                    ? "#909caeff"
                    : "#dee2e6",
                borderWidth:
                  formikProps.values.pricingType === "tiered" ? "2px" : "1px",
              }}
              onClick={() => formikProps.setFieldValue("pricingType", "tiered")}
            >
              <FormGroup check className="mb-0">
                <Label
                  check
                  className="d-flex align-items-start w-100"
                  style={{ cursor: "pointer" }}
                >
                  <Field
                    type="radio"
                    name="pricingType"
                    value="tiered"
                    className="mt-1"
                  />
                  <div className="ml-2 flex-fill">
                    <div className="fw-semibold mb-1">Custom Tiered</div>
                    <small className="text-muted">
                      Set unique prices for each player count
                    </small>
                  </div>
                </Label>
              </FormGroup>
            </div>
          </div>
        </FormGroup>
      </CardBody>
    </Card>
  );
};
